import React from 'react'
import styled, { css } from 'styled-components'
import { Media, mbSize } from '../../theme'
import type { BoxesContentData, BoxItem } from '../../utils'

const BoxesContainer = styled.div<{ $count: number }>`
  display: grid;
  grid-template-columns: ${({ $count }) => {
    if ($count === 1) return '1fr'
    if ($count === 2) return 'repeat(2, 1fr)'
    return 'repeat(3, 1fr)'
  }};
  gap: 20px;
  width: 100%;

  ${Media.lessThan(Media.small)} {
    gap: ${mbSize(26)};
  }
`
const BoxTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px 0;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(36)};
    margin: 0 0 ${mbSize(40)} 0;
  }
`

const BoxContent = styled.div`
  font-size: 16px;
  line-height: 20px;

  ul,
  ol {
    padding-left: 24px;
  }
  li {
    margin: 0 0 16px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    line-height: ${mbSize(30)};
    ul,
    ol {
      padding-left: ${mbSize(40)};
    }
    li {
      margin: 0 0 ${mbSize(32)} 0;
    }
  }
`

const Box = styled.div<{ $backgroundColor?: string; $index: number }>`
  padding: 24px;
  border-radius: 10px;
  ${({ $index, $backgroundColor }) => {
    if (($index + 1) % 2 === 0)
      return css`
        background-color: ${$backgroundColor || '#F5F5F5'};
        border: 1px solid #e5e5e5;
        ${BoxTitle},
        ${BoxContent} {
          color: #333333;
        }
      `
    return css`
      background-color: ${$backgroundColor || '#FFEFEC'};
      border: 1px solid #ffd6ce;
      ${BoxTitle},
      ${BoxContent} {
        color: #f3512b;
      }
    `
  }}
  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(40)};
  }
`

export type BoxesProps = BoxesContentData

export const Boxes: React.FC<BoxesProps> = ({ box1, box2, box3, ...props }) => {
  // 计算实际显示的框数量
  const boxes: (BoxItem | undefined)[] = [box1, box2, box3]
  const validBoxes = boxes.filter((box): box is BoxItem => box !== undefined && box.title !== '')
  const count = validBoxes.length

  if (count === 0) {
    return null
  }

  return (
    <BoxesContainer $count={count} {...props}>
      {validBoxes.map((box, index) => {
        const backgroundColor = box.color
        return (
          <Box key={index} $index={index} $backgroundColor={backgroundColor}>
            {box.title && (
              <BoxTitle
                {...(box.titleAttributes || {})}
                dangerouslySetInnerHTML={{ __html: box.title }}
              />
            )}
            {box.content && (
              <BoxContent
                {...(box.contentAttributes || {})}
                dangerouslySetInnerHTML={{ __html: box.content }}
              />
            )}
          </Box>
        )
      })}
    </BoxesContainer>
  )
}
